export default {
    // apiHost:'http://lkp.docker:8003',
    // apiHost:'https://my-dev.bxb.delivery',
    apiHost:'https://my.bxb.delivery',
}
